/* @ngInject */
function dateValidator(moment) {
  return {
    restrict: "A",
    require: "?ngModel",
    link: function (scope, element, attrs, ctrl) {
      ctrl.$validators.dateValidator = function (modelValue, viewValue) {
        // consider empty models to be valid
        if (ctrl.$isEmpty(modelValue)) return true;

        return moment(viewValue, "DD/MM/YYYY").isValid();
      };
    },
  };
}

export default dateValidator;
